module.exports = __webpack_public_path__ + "img/pin-02.1d799deb.svg";